import { useCallback, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../store/store';
import { useParams } from 'react-router-dom';
import { IScreensByContractResponse } from '../../../../../types/screen';
import { EXTENDED_INTERVAL_UPDATE_DATA } from '../../../../../constants/common';
import { usePolling } from '../../../../../hooks/usePolling';

export interface IActiveCyclesTabInteractor {
  screens: IScreensByContractResponse[];
  isLoading: boolean;

  onDeleteScreen: () => Promise<void>;
}

export const useActiveCyclesTabInteractor = (): IActiveCyclesTabInteractor => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { contractId } = useParams();

  const {
    screens: { getAllByContractId },
  } = useAppDispatch();

  const { screens } = useAppSelector((state) => state.screens);

  const getAllScreensHandler = async (contractId: string) => {
    try {
      if (!contractId) {
        return;
      }

      setIsLoading(true);
      await getAllByContractId({ contractId });
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onDeleteScreenHandler = useCallback(async () => {
    await getAllScreensHandler(contractId);
  }, [contractId]);

  usePolling(() => getAllScreensHandler(contractId), EXTENDED_INTERVAL_UPDATE_DATA, [contractId]);

  return { screens, isLoading, onDeleteScreen: onDeleteScreenHandler };
};
